module.exports = __webpack_public_path__ + "static/media/Asset 3Right Knee.a97ece11.png";